module.exports = __webpack_public_path__ + "static/media/logo-camarabarreirinhas.0d6e2dec.png";